import { render, staticRenderFns } from "./VehicleInsurancesGridBlock.vue?vue&type=template&id=bb098a6a&scoped=true"
import script from "./VehicleInsurancesGridBlock.vue?vue&type=script&lang=js"
export * from "./VehicleInsurancesGridBlock.vue?vue&type=script&lang=js"
import style0 from "./VehicleInsurancesGridBlock.vue?vue&type=style&index=0&id=bb098a6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb098a6a",
  null
  
)

export default component.exports